import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

/**
 * Aviso al crear un vino 'Propio' (no Marca Blanca): reemplaza la navegación
 * automática a /stock. Muestra un resumen de lo que se acaba de cargar y
 * ofrece ir directo a la página pública correspondiente en fincalosastros.com
 * — /shop si el vino no tiene cupo asignado (stock general), /cupo-asignado
 * si sí lo tiene (línea limitada, exclusiva para socios con cupo).
 */
const VinoCreadoModal = ({
  isVisible,
  vinoNombre,
  marca,
  variedad,
  cepas = [],
  anada,
  imagenUrl,
  totalBotellas,
  cuposAsignados = [],
  clientesConCupo = 0,
  onClose,
  onVerStock,
}) => {
  if (!isVisible) return null;

  const tieneCupo = cuposAsignados.length > 0;
  const cupoPorCliente = cuposAsignados.reduce((total, c) => total + (Number(c.cupo_por_cliente) || 0), 0);
  const urlTienda = `https://fincalosastros.com${tieneCupo ? '/cupo-asignado' : '/shop'}`;

  return (
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <motion.div
          className="modal-content"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{ maxWidth: '340px', position: 'relative', padding: '0', paddingBottom: '20px' }}
        >
          <button
            onClick={onClose}
            aria-label="Cerrar"
            style={{
              position: 'absolute', top: '7px', right: '10px', border: 'none',
              background: 'none', fontSize: '25px', color: '#b3b3b3', cursor: 'pointer',
            }}
          >
            ×
          </button>

          {imagenUrl && (
            <img
              src={imagenUrl}
              alt={vinoNombre}
              style={{ width: '100%', maxHeight: '30vh', objectFit: 'contain' }}
            />
          )}

          <div style={{ textAlign: 'center', margin: '0 0 8px' }}>
            <p style={{ fontWeight: 700, fontSize: '16px', margin: '0 0 4px' }}>{marca}</p>
            {variedad && (
              <p style={{ margin: '0 0 4px' }}>{variedad}</p>
            )}
            {cepas.length > 0 && (
              <p style={{ margin: '0 0 4px' }}>{cepas.join(', ')}</p>
            )}
            {anada && (
              <p style={{ margin: '0 0 4px' }}>{anada}</p>
            )}
          </div>

          <p>
            ¡Vino creado! Ya está disponible en{' '}
            <a
              href={urlTienda}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#e65c5c' }}
            >
              fincalosastros.com
            </a>.
          </p>

          <p style={{ fontSize: '13px', color: '#666', fontFamily: 'Effra', margin: '-6px 0 4px' }}>
            {Number(totalBotellas || 0).toLocaleString('es-AR')} botellas embotelladas
            {tieneCupo && (
              <>
                <br />
                {cupoPorCliente} cupos asignados a {clientesConCupo} clientes
              </>
            )}
          </p>

          <div className="modal-buttons" style={{ justifyContent: 'center' }}>
            <button className="button" onClick={onVerStock} style={{ width: 'auto', margin: 0 }}>
              Ir a stock
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default VinoCreadoModal;
